const getConfig = (state, key) => {
  if (state.configs[key]) return state.configs[key]

  return null
}

export default {
  getConfig
}
